import { versionConfig, statusConfig, regionConfig, languageConfig } from '../options.js';
import { CFeaturedContent } from '../../models/featuredContent.js';
const featuredContentModel = new CFeaturedContent();
export const featuredContent = {
    model: featuredContentModel,
    type: 'featured-content',
    contentType: 'featuredContent',
    editor: 'html',
    editorTitle: { name: 'title', placeholder: 'title' },
    documentProperty: 'content',
    title: 'Featured Content',
    plural: 'Featured Content',
    endpoint: 'featuredContent',
    version: versionConfig,
    listing: {
        type: 'grid',
        gridContentType: 'featured-content',
        gridCombineProperty: 'slug',
        gridDecode: ['title'],
        gridJoin: { properties: ['region', 'language'] },
        gridFormat: [
            // todo: move gridDecode into normalized gridFormat { format: 'decode', properties: ['title'] },
            { format: 'date', properties: ['created', 'modified'] },
        ],
        gridColumns: ['title', 'type', 'created', 'modified'],
        gridSearch: [{ key: 'title', combine: true }],
        gridHasChildren: true,
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            { label: 'Type', key: 'type', uppercase: true, default: true },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
    },
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'type',
        'client',
        'region',
        'language',
        'created',
        'modified',
        'tags',
    ],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        images: [{ label: 'Featured Content', name: 'image' }],
    },
    meta: [
        {
            label: 'Featured Content Type',
            name: 'type',
            input: 'select',
            description: 'Controls which Featured Content design is displayed.',
            options: [
                { label: 'Hub Content', value: 'content' },
                { label: 'Client Specific', value: 'client' },
            ],
        },
        {
            label: 'Notes',
            name: 'notes',
            input: 'textarea',
            description: 'Document notes.',
        },
        {
            label: 'Call to Action',
            name: 'cta',
            input: 'text',
            description: 'Enter the Call to Action for the button or link.',
        },
        {
            label: 'URL',
            name: 'url',
            input: 'text',
            description: 'Enter the URL, if any, for the Call to Action button or link. Slugless links only.',
        },
        {
            label: 'Priority',
            name: 'priority',
            input: 'number',
            description: 'Enter the content priority number with 100 being the highest and 0 being the lowest.',
        },
        {
            label: 'Start Date',
            name: 'startDate',
            input: 'datetime-local',
            description: 'Enter the date the Featured Content tile should start being displayed.',
        },
        {
            label: 'End Date',
            name: 'endDate',
            input: 'datetime-local',
            description: 'Enter the date the Featured Content tile should stop being displayed.',
        },
        {
            label: 'Exclude Client',
            name: 'exclude',
            input: 'multiselect',
            description: 'Add clients to prevent them from viewing this article.',
        },
    ],
    validate: [
        { property: 'title' },
        { property: 'slug' },
        { property: 'region' },
        { property: 'language' },
    ],
};
//# sourceMappingURL=featuredContent.js.map